import RowPlaceholder from './RowPlaceholder';

const DropdownPlaceholder: FC = () => (
  <div className="p-2">
    <RowPlaceholder />
    <RowPlaceholder />
    <RowPlaceholder />
    <RowPlaceholder />
    <RowPlaceholder />
    <RowPlaceholder />
    <RowPlaceholder />
    <RowPlaceholder />
    <RowPlaceholder />
    <RowPlaceholder />
    <RowPlaceholder />
    <RowPlaceholder />
  </div>
);

export default DropdownPlaceholder;
